import { render, staticRenderFns } from "./AccountDropdownMenuItems.vue?vue&type=template&id=76de3cf6&scoped=true&"
import script from "./AccountDropdownMenuItems.vue?vue&type=script&lang=ts&"
export * from "./AccountDropdownMenuItems.vue?vue&type=script&lang=ts&"
import style0 from "./AccountDropdownMenuItems.vue?vue&type=style&index=0&id=76de3cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76de3cf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VIcon,VListItem,VListItemTitle})
